import { createRoot } from 'react-dom/client'

import '@fontsource-variable/schibsted-grotesk'
import '@fontsource-variable/geist'
import '@fontsource/dm-serif-display'
import '@/index.css'

import { App } from '@/App'

createRoot(document.getElementById('root')!).render(<App />)
